import $ from 'jquery'
import 'slick-carousel'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


let slideHistory;

export default function livesInit() {
    $('.lives-grid')
    .on('init', function(event, slick, direction){
        // remove all prev/next
        $('.slick-slide').removeClass('prevSlide').removeClass('nextSlide');
        // find current slide
        for (var i = 0; i < slick.$slides.length; i++)
        {
            var $slide = $(slick.$slides[i]);
            if ($slide.hasClass('slick-current')) {
                // update DOM siblings
                $slide.prev().addClass('prevSlide');
                $slide.next().addClass('nextSlide');
                break;
            }
        }
      }
    )
    .on('afterChange', function(event, slick, direction){
        // remove all prev/next
        $('.slick-slide').removeClass('prevSlide').removeClass('nextSlide');
    
        // find current slide
        for (var i = 0; i < slick.$slides.length; i++)
        {
            var $slide = $(slick.$slides[i]);
            if ($slide.hasClass('slick-current')) {
                // update DOM siblings
                slideHistory = i;
                $slide.prev().addClass('prevSlide');
                $slide.next().addClass('nextSlide');
                break;
            }
        }
      }
    )
    .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        // optional, but cleaner maybe
        // remove all prev/next
        $('.slick-slide').removeClass('prevSlide').removeClass('nextSlide');
    })
    .slick({
        dots: true,
        infinite: true,
        slidesToShow: 3,
        centerMode: true,
        touchMove: false,
        // centerPadding: '60px',
        // slidesToScroll: 1,
        variableWidth: true,
    });
    
    if (slideHistory > 0) {
        $('.lives-grid').slick('slickGoTo', slideHistory, true);
    }
}
